module.exports = __webpack_public_path__ + "static/media/sel_03_228.603a7359.mp4";